/**
 * Created by eliorc on 4/4/17.
 */

define(function (require) {
    var leConf = require("assets/config/le-conf");

    function WebAgentDevTools(options) {
        this._options = options;
        // If the current environment is Dev. autoStart
        if (leConf.environment === window.LE.CONST.ENVIRONMENTS.DEV) {
            this.activate();
        }

    }

    WebAgentDevTools.prototype.activate = function activate() {
        this.exposeAccessors();
        this.setDevelopmentTools();
        window.devTools = this;
    };

    WebAgentDevTools.prototype.setDevelopmentTools = function setDevelopmentTools() {
        addConsoleSaveFunctionality();
        function addConsoleSaveFunctionality() {
            window.console.save = function (data, filename) {
                if (!data) {
                    window.console.error('Console.save: No data');
                    return;
                }

                if (!filename) {
                    filename = 'console.json';
                }

                if (typeof data === "object") {
                    data = JSON.stringify(data, function (k, v) {
                        if (v === undefined) {
                            return null;
                        }
                        return v;
                    }, 4);
                }

                var blob = new Blob([data], {type: 'text/json'}),
                    e = document.createEvent('MouseEvents'),
                    a = document.createElement('a');

                a.download = filename;
                a.href = window.URL.createObjectURL(blob);
                a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                a.dispatchEvent(e);
            };
        }

        /**
         * Add here your custom plugins / dev tools / additional libs.
         */
    };

    WebAgentDevTools.prototype.exposeAccessors = function exposeAccessors() {
        this.accessors = {
            amsConnection: this._options.amsConnection,
            app: this._options.app,
            model: this._options.model
        };
        /**
         // Add here accessors to important area in the application.
         */
    };

    return WebAgentDevTools;

});






